/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { SvgIcon } from '@chegg-ui/svg-icon';
import styled from 'styled-components';
// exported for testing
export var directionToDegrees = {
  left: 90,
  right: 270,
  up: 180,
  down: 0
};
export var DirectionalSvgIcon = styled(SvgIcon).withConfig({
  componentId: "sc-14hw0tn-0"
})(["", ""], function (_ref) {
  var pointing = _ref.pointing;

  if (!pointing || pointing === 'down') {
    return '';
  } // covers the ThumbIcon case of needing to "flip" rather than rotate, while also working for Arrow/Chevron


  if (pointing === 'up') {
    return 'transform: scaleY(-1);';
  }

  return "transform: rotate(".concat(directionToDegrees[pointing], "deg);");
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/styles.js
// module id = 467
// module chunks = 11